module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/marko-klaric-avatar-bdfdf266a76fd3918d3c9b7bbfafa731.jpg";